import styled from 'styled-components';
import { Typography } from '@thinknet-gmbh/platform-common-ui';

export const AssignToDetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PopoverContentWrapper = styled.div`
  width: 204px;
  word-wrap: break-word;
`;

export const AssignToRow = styled(Typography)`
  text-overflow: ellipsis;
  overflow: hidden;
  width: 200px;
  height: 100%;
  white-space: nowrap;
`;
